import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './DJCPList.css';

function DJCPList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newDJCP,
    } = functions;

    const { DJCPListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="DJCPList-container">
            {!DJCPListData.length && (
                <h3>No tiene ninguna Declaración de Cosecha Probable</h3>
            )}
            {DJCPListData.length > 0 && (
                <>
                    <TableContainer tableData={tableData} />
                </>
            )}
            {new Date(settings?.djcp_rango_inicio) <= new Date() &&
                new Date() <= new Date(settings?.djcp_rango_fin) && (
                    <div className="DJCPList-footer">
                        <form onSubmit={handleSubmit(newDJCP)}>
                            <select {...register('myViniedo')}>
                                <option value={0}>Elegir Viñedo</option>
                                {viniedos?.map((v) => {
                                    return (
                                        <option key={v.id} value={v.id}>
                                            {v.num}
                                        </option>
                                    );
                                })}
                            </select>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={EnableBtn === 0}
                            >
                                Nueva DJCP
                            </button>
                        </form>
                    </div>
                )}
        </div>
    );
}

export default DJCPList;
